import React, { useEffect, useState } from "react";
import { CancelOrder, CancelOrderByAdmin, createdPass, PaidOrderByAdmin } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function usePaidOrder(props: {
	reload: () => void;
	user?: User | null;
	setLoad: (val: boolean) => void;
}) {
	const { openAlertDialog } = useAlertDialog();
	const doPaidOrder = async (id: number) => {
		props.setLoad(true);
		try {
			await PaidOrderByAdmin(id);
			props.setLoad(false);
			openAlertDialog?.(AlertType.Success, "Confirmation of payment successfully!", () => {
				props.reload();
			});
		} catch (err: any) {
			console.error(err);
			props.setLoad(false);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "Confirmation of payment Fail!");
		}
	};

	return {
		doPaidOrder,
	};
}
